import React, { Component, PropTypes } from 'react';
import { Modal } from 'react-bootstrap';
import programs from 'programs';
import './completeLevelModal.scss';

export default class CompleteLevelModal extends Component {

  static propTypes = {
    session: PropTypes.object.isRequired,
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    complete: PropTypes.func.isRequired,
    exitNoComplete: PropTypes.func.isRequired
  }

  static contextTypes = {
    i18n: PropTypes.func.isRequired
  }

  cancel (evt) {
    const { closeModal } = this.props;
    closeModal();
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  handleComplete (evt) {
    const { complete } = this.props;
    complete();
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  handleExitNoComplete (evt) {
    const { exitNoComplete } = this.props;
    exitNoComplete();
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }


  render () {
    const {
      showModal,
      closeModal,
      session: {
        programId,
        currentLevel
      }
    } = this.props;
    const { i18n: _ } = this.context;
    const program = programs.programLookup[programId];
    const { levels } = program;
    let nextLevel = String(Number(currentLevel) + 1);
    if (!levels[nextLevel]) {
      nextLevel = 'completed';
    }

    return (
      <Modal show={showModal} onHide={closeModal} className="spectacle-deck complete-level">
        <Modal.Header closeButton>
          <Modal.Title>{_`Completed Level ${currentLevel}`}!</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <h3>
          { nextLevel !== 'completed'
          ? _('Proceed to the next level?')
          : _('All levels completed! Mark as done?')
          }
          </h3>

          { nextLevel !== 'completed' &&
            <p>({_('takes effect on the next launch')}</p>
          }

          <button
              className="btn btn-default"
              onClick={::this.handleComplete}>
            { nextLevel !== 'completed'
            ? _`Yes, I just finished this Level with my class! Continue on to Level ${nextLevel}`
            : _('Yes, all done!')
            }
          </button>

          <button
              className="btn btn-default"
              onClick={::this.handleExitNoComplete}>
            {_`No, I was just previewing the content. Exit and stay on Level ${currentLevel}`}
          </button>

        </Modal.Body>
      </Modal>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/session/presentation/components/completeLevelModal.jsx